import "jquery-validation"; //nmp
import "jquery.numeric"; // npm
require('./core/formbuilder/jquery.numeric_input');
require('./core/formbuilder/jquery-metadata');
require('./core/formbuilder/form');

